(function () {
  var STORAGE_KEY = 'linuaPopupState';
  var SHOW_DELAY_MS = 8000;
  // Never interrupt checkout, the account area or the Custom Studio (people are mid-design there).
  var SKIP_PATHS = ['/cart', '/checkout', '/account', '/pages/custom-studio'];

  var popup = document.getElementById('linua-popup');
  if (!popup) return;

  var path = window.location.pathname;
  if (SKIP_PATHS.some(function (p) { return path.indexOf(p) === 0; })) return;

  var state = null;
  try {
    state = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
  } catch (e) {
    state = null;
  }
  if (state && (state.dismissed || state.subscribed)) return;

  var wasSubmitted = !!popup.querySelector('[data-linua-popup-code]');

  function persist(data) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      /* localStorage unavailable — popup just won't remember dismissal */
    }
  }

  function open() {
    popup.hidden = false;
    requestAnimationFrame(function () {
      popup.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    var input = document.getElementById('LinuaPopupEmail');
    if (input) input.focus({ preventScroll: true });
  }

  function close(markDismissed) {
    popup.classList.remove('is-open');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      popup.hidden = true;
    }, 200);
    if (markDismissed) persist({ dismissed: true });
  }

  popup.querySelectorAll('[data-linua-popup-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      close(true);
    });
  });

  var copyButton = popup.querySelector('[data-linua-popup-copy]');
  if (copyButton) {
    copyButton.addEventListener('click', function () {
      var code = popup.querySelector('.linua-popup__code-value').textContent.trim();
      var reset = function () {
        copyButton.textContent = 'Copy';
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function () {
          copyButton.textContent = 'Copied!';
          window.setTimeout(reset, 2000);
        });
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) close(true);
  });

  if (wasSubmitted) {
    persist({ subscribed: true });
    open();
    return;
  }

  window.setTimeout(open, SHOW_DELAY_MS);
})();
